


// import React, {
// useState,
// useEffect
// } from "react";

// import { NavLink,useNavigate } from "react-router-dom";

// import axios from "axios";

// import {

// LayoutDashboard,
// FolderKanban,
// Mail,
// Users,
// BadgeCheck,
// BarChart3,
// Menu,
// ChevronLeft,
// ChevronRight,
// LogOut
// } from "lucide-react";

// import "./sidebar.css";
// import { logoutUser } from "../../services/AuthService";

// function Sidebar() {
// const navigate = useNavigate();

// const [menus,setMenus] = useState([]);

// const [mobileOpen,setMobileOpen] =
// useState(false);

// const [collapsed,setCollapsed] =
// useState(false);

// const userData = JSON.parse(
// localStorage.getItem("user")
// );

// const roleTitle =
// userData?.role === "Admin"
// ? "IGNIS ADMIN"
// : "PM PORTAL";


// const iconMap = {

// dashboard: <LayoutDashboard size={20} />,

// folder: <FolderKanban size={20} />,

// mail: <Mail size={20} />,

// users: <Users size={20} />,

// check: <BadgeCheck size={20} />,

// chart: <BarChart3 size={20} />
// };


// useEffect(() => {

// fetchMenus();

// },[]);


// const fetchMenus = async () => {

// try {

// const token = localStorage.getItem(
// "token"
// );

// const response = await axios.get(

// "http://localhost:8000/api/menus/",

// {
// headers:{
// Authorization:`Bearer ${token}`
// }
// }

// );

// setMenus(response.data);

// } catch(err){

// console.error(
// "Failed to fetch menus",
// err
// );

// }

// };



//   const handleLogout = async () => {
//     try {
//       await logoutUser();
//       navigate("/");
//     } catch (error) {
//       console.error("Logout Error:", error);
//       navigate("/");
//     }
//   };

// return (

// <>

// {/* DESKTOP COLLAPSE BUTTON */}

// <button
// className="collapse-btn"
// style={{
// left: collapsed ? "60px" : "230px"
// }}
// onClick={() =>
// setCollapsed(!collapsed)
// }
// >

// {
// collapsed
// ? <ChevronRight size={18} />
// : <ChevronLeft size={18} />
// }

// </button>


// {/* SIDEBAR */}

// <div className={`sidebar
// ${mobileOpen ? "open" : ""}
// ${collapsed ? "collapsed" : ""}
// `}>

// <div className="sidebar-header">

// {
// !collapsed && (
// <h2>{roleTitle}</h2>
// )
// }

// </div>


// <div className="sidebar-menu">

// {
// menus.map((item,index)=>(

// <NavLink

// key={index}

// to={`/admin${item.path}`}

// className={({isActive}) =>
// isActive
// ? "menu-item active"
// : "menu-item"
// }

// onClick={() =>
// setMobileOpen(false)
// }
// >

// <span className="menu-icon">

// {iconMap[item.icon]}

// </span>

// {
// !collapsed && (
// <span>{item.name}</span>
// )
// }

// </NavLink>

// ))
// }

// </div>
// <div className="sidebar-footer">
//   <button
//     className="logout-btn"
//     onClick={handleLogout}
//   >
//     <LogOut size={18} className="logout-icon" />

//     {!collapsed && (
//       <span>Logout</span>
//     )}
//   </button>
// </div>
// </div>


// {/* MOBILE MENU BUTTON */}

// <button
// className="mobile-menu-btn"
// onClick={() =>
// setMobileOpen(!mobileOpen)
// }
// >

// {
// mobileOpen
// ? <ChevronLeft size={22} />
// : <Menu size={22} />
// }

// </button>




// </>

// )

// }

// export default Sidebar;

import React, {
  useState,
  useEffect
} from "react";

import {
  NavLink,
  useNavigate
} from "react-router-dom";

import axios from "axios";

import {
  LayoutDashboard,
  FolderKanban,
  Mail,
  Users,
  BadgeCheck,
  BarChart3,
  Menu,
  ChevronLeft,
  ChevronRight,
  LogOut,
  Terminal
} from "lucide-react";

import "./sidebar.css";
import { logoutUser } from "../../services/AuthService";

function Sidebar() {
  const navigate = useNavigate();

  const [menus, setMenus] = useState([]);
  const [mobileOpen, setMobileOpen] =useState(false);
  const [collapsed, setCollapsed] =useState(false);

  const userData = JSON.parse(localStorage.getItem("user"));
  const Base_URL = process.env.REACT_APP_API_BASE_URL;

  const isAdmin =userData?.role === "Admin";

  const basePath = isAdmin ? "/admin": "/pm";

  const roleTitle = isAdmin? "IGNIS ADMIN": "PM PORTAL";

  const iconMap = {dashboard: (<LayoutDashboard size={20} />),

    folder: (
      <FolderKanban size={20} />
    ),

    mail: <Mail size={20} />,

    users: <Users size={20} />,

    check: (
      <BadgeCheck size={20} />
    ),

    chart: (
      <BarChart3 size={20} />
    ),
    terminal: <Terminal size={18} />
  };

  useEffect(() => {
    fetchMenus();
  }, []);

  const fetchMenus = async () => {
    try {
      const token =
        localStorage.getItem(
          "token"
        );

      const response =
        await axios.get(
          `${Base_URL}/api/menus/`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

      setMenus(response.data);
    } catch (err) {
      console.error(
        "Failed to fetch menus",
        err
      );
    }
  };

  const handleLogout =
    async () => {
      try {
        await logoutUser();

        localStorage.removeItem(
          "token"
        );
        localStorage.removeItem(
          "refresh"
        );
        localStorage.removeItem(
          "user"
        );

        navigate("/");
      } catch (error) {
        console.error(
          "Logout Error:",
          error
        );

        navigate("/");
      }
    };

  return (
    <>
      {/* DESKTOP COLLAPSE BUTTON */}
      <button
        className="collapse-btn"
        style={{
          left: collapsed
            ? "60px"
            : "230px"
        }}
        onClick={() =>
          setCollapsed(
            !collapsed
          )
        }
      >
        {collapsed ? (
          <ChevronRight
            size={18}
          />
        ) : (
          <ChevronLeft
            size={18}
          />
        )}
      </button>

      {/* SIDEBAR */}
      <div
        className={`sidebar
        ${
          mobileOpen
            ? "open"
            : ""
        }
        ${
          collapsed
            ? "collapsed"
            : ""
        }`}
      >
        {/* HEADER */}
        <div className="sidebar-header">
          {!collapsed && (
            <h2>
              {roleTitle}
            </h2>
          )}
        </div>

        {/* MENU */}
        <div className="sidebar-menu">
          {menus.map(
            (
              item,
              index
            ) => (
              <NavLink
                key={index}
                to={`${basePath}${item.path}`}
                className={({
                  isActive
                }) =>
                  isActive
                    ? "menu-item active"
                    : "menu-item"
                }
                onClick={() =>
                  setMobileOpen(
                    false
                  )
                }
              >
                <span className="menu-icon">
                  {
                    iconMap[
                      item
                        .icon
                    ]
                  }
                </span>

                {!collapsed && (
                  <span>
                    {
                      item.name
                    }
                  </span>
                )}
              </NavLink>
            )
          )}
        </div>

        {/* FOOTER */}
        <div className="sidebar-footer">
          <button
            className="logout-btn"
            onClick={
              handleLogout
            }
          >
            <LogOut
              size={18}
              className="logout-icon"
            />

            {!collapsed && (
              <span>
                Logout
              </span>
            )}
          </button>
        </div>
      </div>

      {/* MOBILE BUTTON */}
      <button
        className="mobile-menu-btn"
        onClick={() =>
          setMobileOpen(
            !mobileOpen
          )
        }
      >
        {mobileOpen ? (
          <ChevronLeft
            size={22}
          />
        ) : (
          <Menu
            size={22}
          />
        )}
      </button>
    </>
  );
}

export default Sidebar;